import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { useRouter } from 'next/router';
import { Card, Table } from '@avila-tek/ui/src';
import { Currency, PageInfo, Pagination } from '../../models';
import { ActiveDotCell } from '../shared';

const columnHelper = createColumnHelper<Currency>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Nombre',
  }),

  columnHelper.accessor('symbol', {
    header: 'Simbolo',
  }),

  columnHelper.accessor('rate', {
    header: 'Tasa',
  }),

  columnHelper.accessor('active', {
    header: 'Estatus',
    cell: (info) => <ActiveDotCell active={info?.getValue()} />,
  }),
];

interface CurrencyTableProps {
  data: Pagination<Currency>;
  pagination: Partial<PageInfo>;
  setPagination: React.Dispatch<React.SetStateAction<Partial<PageInfo>>>;
}

function CurrencyTable({
  data,
  pagination,
  setPagination,
}: CurrencyTableProps) {
  const router = useRouter();

  const onClickRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    router.push(`/app/settings/currencies/${id}`);
  };

  const onClickAddButton = () => router.push('/app/settings/currencies/create');

  const handleGoToPage = (value: number) => {
    setPagination({ ...pagination, currentPage: value });
  };

  return (
    <Card className="overflow-x-auto p-5">
      <Table<Currency>
        data={data.items}
        columns={columns}
        href="/app/settings/currency/create"
        manualPagination
      >
        <Table.Header>
          <Table.SearchInput />
          <Table.AddButton title="Moneda" action={onClickAddButton} />
        </Table.Header>
        <Table.Content<Currency> onClickRow={onClickRow} />
        <Table.Footer>
          <Table.Pagination
            handleGoToPage={handleGoToPage}
            paginationInfo={{
              count: data.count,
              pageInfo: { ...data.pageInfo },
            }}
            className="ml-auto"
          />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default CurrencyTable;
